module.exports = __webpack_public_path__ + "img/slotmill.ff56c435.png";